import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ModulAPI from '../../../api/ModulAPI';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import Util from '../../../util/Util';
import ApiUiController from '../../../controller/ApiUiController';
import FieldListRows from './FieldListRows';
import FieldListHeader from './FieldListHeader';

class ModelFieldList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      inApiCall: true, popup: false, field: {
        id: 0, label_name: '',
        field_type: '', validate: '*', is_visible: 0, editable: 0, duplicate: 0,
        field_order: 0, model_no: 0
      }
    };

    this.path = props.match.path;
    this.path = this.path.replace('/:modelId', '');
    this.modelNo = parseInt(props.match.params.modelId);
    this.model = reactLocalStorage.getObject(Const.Model);
    const key = Object.keys(this.model).find(key => this.model[key].model_no === this.modelNo);
    this.model = this.model[key];
    this.fields = this.loadModelList();
    this.i = -1;
    this.fieldOptions = [{ label: 'Text', value: Const.Text },
    { label: 'TextArea', value: Const.TextArea }, { label: 'Single Select', value: Const.Select },
    { label: 'Multiple Select', value: Const.MultiSelect },
    { label: 'Date', value: Const.Date }, { label: 'Date Time', value: Const.DateTime }];

    this.validationOptions = [{ label: 'Compulsory', value: Const.Mandatory },
    { label: 'Not Compulsory', value: Const.NonMandatory }];

    this.permissions = [];
    this.role = parseInt(props.match.params.innerId);
    const roles = reactLocalStorage.getObject(Const.Model).role.options;
    for (let i = 0; i < roles.length; i++) {
      if (roles[i].value === this.role) this.permissions = roles[i].permission;
    }
  }
  componentDidMount() { ModulAPI.get(this.modelNo, this.onReceived, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = module => {
    this.model = module;
    this.fields = this.loadModelList();
    this.setState({ inApiCall: false });
  };

  loadModelList = () => {
    let fields = Object.keys(this.model.fields).map(key => this.model.fields[key]);
    fields = fields.filter(field => field.status !== Const.Trash);

    //Apply Role permission to main fields
    const permissions = this.permissions;
    if (permissions) {
      for (let i = 0; i < permissions.length; i++) {
        if (permissions[i].role_id !== this.role) continue;
        const field = fields.find(field => field.id === permissions[i].field_id);
        if (field) {
          field.visible = permissions[i].visible;
          field.editable = permissions[i].editable;
          field.form_mandate = permissions[i].form_mandate;
        }
      }
    }
    //end
    return fields;
  };

  show = i => {
    this.i = i;
    let field;
    if (i !== -1) {
      //if(this.isGlobal) field = { ...this.fields[i] };
      //else {
      const permission = this.permissions.find(perm => perm.field_id === this.fields[i].id);
      if (permission === undefined)
        field = {
          id: 0, role_id: this.role, model_no: this.modelNo,
          field_id: this.fields[i].id, label_name: '', visible: 1, editable: 1,
          form_mandate: 0
        };
      else field = { ...permission };
      //}
    } else {
      field = {
        id: 0, model_no: this.modelNo, field_type: '', label_name: '',
        field_order: this.fields.length, visible: 1, editable: 1, validate: '',
        non_duplicate: 0, form_mandate: 0, api_mandate: 0, import_mandate: 0,
        default_value: ''
      };
    }
    this.setState({ ...this.state, popup: true, selected: '', field: field });
  };
  hide = () => this.setState({ ...this.state, popup: false });

  onCheckChange = (key, val) => {
    const field = { ...this.state.field };
    if (key === 'visible' && !val) field['form_mandate'] = Const.False;
    field[key] = val ? Const.True : Const.False;
    this.setState({ ...this.state, field: field });
  };
  onFieldTypeChange = selected => {
    this.setState({ ...this.state, selected: selected });
    this.onChange('field_type', selected !== null ? selected.value : '');
  };
  onChange = (key, val) => {
    const field = { ...this.state.field }; field[key] = val;
    this.setState({ ...this.state, field: field });
  };

  submit = () => {
    this.setState({ ...this.state, popup: false });
    const title = this.i !== -1 ? 'Update' : 'Add';
    const message = this.i !== -1
      ? 'Are you sure you want Change Field ?' : 'Are you sure you want Add Field ?';
    Util.confirmAlert(title, message, title, 'No',
      () => {
        this.setState({ ...this.state, inApiCall: true });
        ModulAPI.saveInnerField(this.state.field, this.onSuccess, this.onFail);
      });
  };
  onSuccess = () => {
    Util.showNotification('Successful', 'Field changed successfully.', 'success');
    this.setState({ ...this.state, inApiCall: false });
    this.props.onModuleChanged();
    this.fields = this.loadModelList();
  };

  delete = i => {
    Util.confirmAlert('Delete', `Are you sure you want to delete ${this.fields[i].label_name}`,
      'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        ModulAPI.deleteField(this.fields[i].id, this.onDeleteSuccess, this.onFail);
      });
  };
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Delete successfully.', 'success');
    this.props.onModuleChanged();
    this.fields = this.loadModelList();
  };

  render() {
    return (
      <>
        <Modal show={this.state.popup} onHide={this.hide}
          size="md" aria-labelledby="contained-modal-title-vcenter" centered>

          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter"> Field </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form className="fieldmodulef">
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Check checked={this.state.field.visible === Const.True}
                    onChange={evt => this.onCheckChange('visible', evt.target.checked)} />
                  <Form.Label>Visible</Form.Label>
                </Col>
              </Row>

              {(this.fields[this.i] === undefined
                || this.fields[this.i].status !== Const.SpecialField) &&
                <Row className="row-cols-2 colmr">
                  <Col xs={12}>
                    <Form.Check checked={this.state.field.editable === Const.True}
                      onChange={evt => this.onCheckChange('editable', evt.target.checked)} />
                    <Form.Label>Editable</Form.Label>
                  </Col>
                </Row>
              }

              {(this.fields[this.i] === undefined
                || this.fields[this.i].status !== Const.SpecialField) &&
                <Row className="row-cols-2 colmr">
                  <Col xs={12}>
                    <Form.Check
                      onChange={evt => this.onCheckChange('form_mandate', evt.target.checked)}
                      checked={this.state.field.form_mandate === Const.True} />
                    <Form.Label>Form Mandatory/ Compulsory</Form.Label>
                  </Col>
                </Row>
              }
            </Form>
          </Modal.Body>

          <Modal.Footer> <Button onClick={this.submit}>Submit</Button> </Modal.Footer>
        </Modal>

        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-8 ">
                <h3>{this.model.model_name} Field List</h3>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 tablefield">
                <Table striped bordered hover>
                  <FieldListHeader context={this.props.context} />
                  <ApiUiController inApiCall={this.props.inApiCall}>
                    <FieldListRows fields={this.fields} show={this.show} Update={true}
                      delete={this.delete} path={this.path} context={this.props.context} />
                  </ApiUiController>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(ModelFieldList);